module.exports = __webpack_public_path__ + "static/img/arooma-g.ce4655dc.png";